import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import LoadingPanel from '@/component/common/LoadingPanel';
import ErrorModal from '@/component/common/modal/ErrorModal';
import { getChatPostListByChatThreadId, getIndexChatPostMsg } from '@/service/chatPostService';
import { getListChatThreadForTicketKnowledge } from '@/service/chatThreadService';
import { getTicketById } from '@/service/ticketService';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { reloadChatThreadPanelAtom } from '@/state/atom/panelAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { isExChangeTicket } from '@/state/ticketState';
import { useEffect, useReducer, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
    addChatPostToList,
    deleteChatPostToList,
    updateChatPostToList
} from '../handler/ChatPostHandler';
import { disableAutoScroll } from '../handler/FootprintHandler';
import { unsubscribeAll } from '../handler/SubsciptionHandler';
import ChatKnowledge from './ChatKnowledge';
import './ChatThreadKnowledge.css';
import {
    getUserListCanMention,
} from '@/component/chatThread/handler/ChatThreadHandler';
import { getListActiveB2BCustomerSelector, getListActiveB2BHelpdeskSelector } from '@/state/selector/ticketSelector';
import { getCorporationById } from '@/service/organizationService';
import sessionStorageUtil from '@/common/utils/sessionStorageUtil';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ChatThreadKnowledge(props) {
    useTranslationSubscription();
    // common corporationDetail state
    const corporationDetail = useRecoilValue(
        corporationAtom
    );

    // common userDetail state
    const [userDetail, setUserDetail] = useRecoilState(userAtom);
    const [fromMsg, setFromMsg] = useState(0);

    // common projectInuseState state
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);
    const [reload, setReload] = useRecoilState(reloadChatThreadPanelAtom);
    const [exChangeTicket, setExchangeTicket] = useRecoilState(isExChangeTicket);

    const [isLoading, setIsLoading] = useState(false);
    const [lastedCountList, setLastedCountList] = useState(0);

    const ticketIdSelected = props?.ticketId;
    const [knowledgeThread, setKnowledgeThread] = useState({});
    let corporationId = corporationDetail.id;

    const [ticketInfo, setTicketInfo] = useState({});
    const [selectThread, setSelectThread] = useState({});

    const [isShowAllChatPost, setIsShowAllChatPost] = useState(true);
    const [chatPostAllList, setChatPostAllList] = useReducer(Utils.reducerDataList, []);

    const [fileUploadedList, setFileUploadedList] = useState([]);
    const [chatPostUpdate, setChatPostUpdate] = useState({});
    const [fileUploading, setFileUploading] = useState({});
    const [chatPostInsertFail, setChatPostInsertFail] = useState({});
    const [isDataChanged, setIsDataChanged] = useState(false);
    const [isModalUploadFileError, setIsModalUploadFileError] = useState(false);
    const [userChatList, setUserChatList] = useState([]);
    const [subsciptionChatPostUpdateResponse, setSubsciptionChatPostUpdateResponse] = useState({});
    const [userListCanMention, setUserListCanMention] = useState([]);
    const [projectIdListForSubscriptionMention, setProjectIdListForSubscriptionMention] = useState([]);
    const [chatThreadCorporationDetail, setChatThreadCorporationDetail] = useState({});

    const listB2BCustomerRecoilState = useRecoilValue(getListActiveB2BCustomerSelector);
    const listB2BHelpdeskRecoilState = useRecoilValue(getListActiveB2BHelpdeskSelector);
    const [focusedMsgId, setFocusedMsgId] = useState(null);

    useEffect(() => {
        return () => {
            // if destroy component then set auto scroll position footprint is true
            disableAutoScroll(false);

            // unsubscribe all
            unsubscribeAll(props.panelId);

            setFromMsg(0);
            setIsLoading(false);
            setLastedCountList(0);
            setKnowledgeThread({});
            setTicketInfo({});
            setSelectThread({});
            setIsShowAllChatPost(true);
            setChatPostAllList([]);
            setFileUploadedList([]);
            setChatPostUpdate({});
            setFileUploading({});
            setChatPostInsertFail({});
            setIsDataChanged(false);
            setIsModalUploadFileError(false);
            setUserChatList([]);
            setSubsciptionChatPostUpdateResponse({});
            setUserListCanMention([]);
            setProjectIdListForSubscriptionMention([]);

        };
    }, []);

    useEffect(() => {
        const controller1 = new AbortController();
        setIsLoading(true);

        getTicketById(props?.API, ticketIdSelected,true)
            .then(async ticketData => {
                let [listThreadData, ticketAffiliationOrganization] = await Promise.all([
                    getListChatThreadForTicketKnowledge(props?.API, ticketData),
                    getCorporationById(null, ticketData?.affiliationOrganization)
                ]); 
                
                setTicketInfo(ticketData);
                setChatThreadCorporationDetail(ticketAffiliationOrganization);
                if (!Utils.isEmptyArray(listThreadData)) {
                    setKnowledgeThread(listThreadData[0]);
                    setSelectThread(listThreadData[0]);
                    await getAllDataChatPost(listThreadData[0]);
                    setIsLoading(false);
                    setExchangeTicket(false);
                } else {
                    setIsLoading(false);
                    setExchangeTicket(false);
                }
            })
            .catch(err => {
                setIsLoading(false);
            });
            
        return () => {
            controller1.abort();
        }
    }, [reload, props?.triggerReload]);

    const getAllDataChatPost = async threadKnowledge => {
        let threadIdList = [];
        let corporationIdList = [];
        if (threadKnowledge) {
            threadIdList.push(threadKnowledge.id);
            corporationIdList.push(threadKnowledge.corporationId);
        }

        let cursor = 0;
        let isContinue = false;
        let msgIdStorage = sessionStorageUtil.getFocusedMsgIdKL() || null;

        do {
            let posts = await getChatPostListByChatThreadId(
                props?.API,
                threadIdList,
                cursor > 0 ? cursor : fromMsg
            );

            if (!Utils.isEmptyObject(posts)) {
                setUserChatList(prev => prev.concat(posts.userChatList || []));
                setChatPostAllList({
                    type: isContinue
                        ? Constant.ACTION_CHANGE_LIST_DATA_TYPE.CONCAT
                        : Constant.ACTION_CHANGE_LIST_DATA_TYPE.INITIAL,
                    posts: posts.chatPostAllList || []
                });
                setLastedCountList(posts.chatPostAllList.length);

                if (msgIdStorage) {
                    const msg = posts.chatPostAllList.find(i => i.id === msgIdStorage);
                    if (msg) {
                        isContinue = false;
                        msgIdStorage = null;
                        cursor = 0;
                        sessionStorageUtil.deleteFocusedMsgIdKL();
                        setFocusedMsgId(msg.id);
                    } else if (!msg && !posts.chatPostAllList.length) {
                        msgIdStorage = null;
                        sessionStorageUtil.deleteFocusedMsgIdKL();
                    } else {
                        isContinue = true;
                        cursor += Constant.CHAT_PAGINATION_DEFAULT_RECORD;
                        setFromMsg(prev => prev + Constant.CHAT_PAGINATION_DEFAULT_RECORD);
                        setFocusedMsgId(null);
                    }
                }
            }
        } while (msgIdStorage);
    };

    useEffect(() => {
        let post = chatPostUpdate;
        if (Utils.isEmptyObject(post)) {
            return;
        }
        if (post.subcriptionType === Constant.SUBSCRIPTION_TYPE.DELETE) {
            deleteChatPostToList(
                post,
                chatPostAllList,
                setChatPostAllList,
                isDataChanged,
                setIsDataChanged
            );
            return;
        }
        if (post.subcriptionType === Constant.SUBSCRIPTION_TYPE.UPDATE) {
            delete post.subcriptionType;
            updateChatPostToList(
                post,
                chatPostAllList,
                setChatPostAllList,
                isDataChanged,
                setIsDataChanged
            );
            return;
        }
        addChatPostToList(
            props?.API,
            corporationId,
            post,
            chatPostAllList,
            setChatPostAllList,
            fileUploadedList,
            setFileUploadedList,
            isDataChanged,
            setIsDataChanged,
            userDetail,
            userChatList,
            setUserChatList
        );
    }, [chatPostUpdate]);

    useEffect(() => {
        if (Utils.isEmptyObject(chatPostInsertFail)) {
            return;
        }
        updateStatusChatPostInsert(chatPostInsertFail);
    }, [chatPostInsertFail]);

    useEffect(() => {
        const controller2 = new AbortController();
        if (
            !Utils.isEmptyObject(selectThread) &&
            !Utils.isEmptyObject(ticketInfo) &&
            selectThread.ticketId === ticketInfo.id
        ) {
            setIsLoading(true);
            getUserListCanMention({
                API: props?.API,
                selectThread,
                ticketInfo,
                ticketOriginInfor: ticketInfo,
                selectedProjectId: projectInuseDetail?.id,
                userDetail,
                corporationDetail,
                projectIdListForSubscriptionMention,
                setProjectIdListForSubscriptionMention,
                listB2BCustomerRecoilState,
                listB2BHelpdeskRecoilState,
            })
                .then(userListMention => {
                    userListMention = userListMention?.filter(user => user?.id === Constant.CHAT_MENTION_ALL.id || user.active === Constant.ACTIVE_FLAG.ACTIVE)
                    setUserListCanMention(userListMention);
                })
                .catch(error => console.log(error))
                .finally(() => setIsLoading(false));
        }

        return () => {
            controller2.abort();
        }
    }, [selectThread, ticketInfo]);


    const updateStatusChatPostInsert = (msg) => {
        if (!msg.status) {
            let postFail = { ...msg.data };
            let msgIndex = getIndexChatPostMsg(chatPostAllList, postFail);
            if (msgIndex >= 0) {
                postFail.insertFail = true;
                setChatPostAllList({
                    type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.REPLACE,
                    newPost: postFail,
                    postIndex: msgIndex,
                });
                setIsDataChanged(!isDataChanged);
            }
        }
    };

    return (
        <div className="mainWrap">
            <LoadingPanel isLoading={isLoading} />
            <div className="mainFlex">
                <div className="col2">
                    <ChatKnowledge
                        key={selectThread?.id}
                        API={props?.API}
                        ticketInfo={ticketInfo}
                        setTicketInfo={setTicketInfo}
                        selectThread={selectThread}
                        setIsLoading={setIsLoading}
                        isShowAllChatPost={isShowAllChatPost}
                        setIsShowAllChatPost={setIsShowAllChatPost}
                        chatPostAllList={chatPostAllList}
                        userDetail={userDetail}
                        setUserDetail={setUserDetail}
                        setChatPostAllList={setChatPostAllList}
                        fileUploadedList={fileUploadedList}
                        setFileUploadedList={setFileUploadedList}
                        knowledgeThread={knowledgeThread}
                        isDataChanged={isDataChanged}
                        setChatPostInsertFail={setChatPostInsertFail}
                        history={props.history}
                        ticketIdSelected={ticketIdSelected}
                        setChatPostUpdate={setChatPostUpdate}
                        panelId={props.panelId}
                        panelType={props.panelType}
                        userChatList={userChatList}
                        setUserChatList={setUserChatList}
                        subsciptionChatPostUpdateResponse={subsciptionChatPostUpdateResponse}
                        setSubsciptionChatPostUpdateResponse={setSubsciptionChatPostUpdateResponse}
                        lastedCountList={lastedCountList} 
                        setLastedCountList={setLastedCountList}
                        setFromMsg={setFromMsg}
                        fromMsg={fromMsg}
                        chatPostUpdate={chatPostUpdate}
                        projectInuseDetail={projectInuseDetail}
                        setProjectInuseDetail={setProjectInuseDetail}
                        projectIdListForSubscriptionMention={projectIdListForSubscriptionMention}
                        userListCanMention={userListCanMention}
                        triggerReloadKnowledgeChat={reload}
                        setTriggerReloadKnowledgeChat = {setReload}
                        corporationDetail={corporationDetail}
                        chatThreadCorporationDetail={chatThreadCorporationDetail}
                        focusedMsgId={focusedMsgId}
                        setFocusedMsgId={setFocusedMsgId}
                    />
                </div>
            </div>
            <ErrorModal
                open={isModalUploadFileError}
                message={`${fileUploading?.file?.name} ${trI18n('USER04MSG004')}`}
                handleCloseDialog={() => setIsModalUploadFileError(false)}
                title={'Upload fail'}
            ></ErrorModal>
        </div>
    );
}
